export const NTB_JOURNEY = 'ntb',
  EXISTING_JOURNEY = 'existing',
  PRE_ASSESSED_JOURNEY = 'pre_assessed',
  ORIGIN_IB = 'ib',
  DELAY_TIMOUT_MS = 4000,
  FORBIDDEN_ACCESS_CODE = 403,
  NO_API_FAILED_ATTEMPT = 3,
  PRE_CONTRACT_DOC_NAME = 'preContract.pdf',
  LOAN_AGREEMENT_DOC_NAME = 'loanAgreement.pdf',
  CONGRATS_REFERRER = 'CO',
  YES_VALUE = 'Yes',
  NO_VALUE = 'No',
  LOAN_TYPE = 'loan',
  CREDIT_CARD_TYPE = 'credit_card',
  CURRENT_TYPE = 'current',
  BUSINESS_CURRENT_ACCOUNT = 'business current',
  EXTERNAL_TYPE = 'external',
  DEBT_CONSOLIDATION = 'Debt Consolidation',
  HOME_IMPROVEMENTS = 'Home Improvements',
  CAR = 'Car',
  WEDDING = 'Wedding',
  HOLIDAY = 'Holiday',
  OTHER = 'Other',
  EMPLOYMENT_REFERRER = 'ED',
  TASK_PENDING_DOCUMENT_RECEIVED = 'TSK-21',
  TASK_PENDING_PRODUCT_DECISION = 'TSK-23',
  TASK_PENDING_OTHER_REFERENCE = 'TSK-24',
  TASK_APPLICATION_EXPIRED = 'TSK-09',
  TASK_APPLICATION_CANCELLED = 'TSK-10',
  SOLE_TYPE = 'Sole',
  JOINT_TYPE = 'Joint',
  PHONE_NUMBER = '0800 707 6471',
  TASK_CREDIT_DECLINE = 'TSK-04',
  TASK_ACCOUNT_OPENED = 'TSK-07',
  TASK_ID_CHECK_CANT_DONE = 'TSK-02',
  TASK_HOOYU_VERIFY_IDENTITY = 'TSK-28',
  FPN_DOCUMENT_URL = '/documents/FairProcessingNotice-VMFULLPNV16.pdf?external=true',
  KEY_FEATURES_DOCUMENT_URL = '/documents/VM-KeyFeatures.pdf?external=true',
  VM_SECURITY_URL = 'https://uk.virginmoney.com/virgin/security.jsp?external=true',
  BRANCH_LOCATOR_URL = 'https://uk.virginmoney.com/store-finder/',
  FIVE_MINUTES_IN_MS = 5 * 6 * 1000,
  THIRTY_MINUTES_IN_MS = 30 * 60 * 1000,
  ACCOUNT_SERVICE_TANDC_MESSAGE = 'Bearer realm error=tsandcs_user',
  SKIP_DIP_PROCESS_FALSE = 'false',
  PRIVACY_NOTICE_DIP_URL =
    'https://apps.cybonline.co.uk/cyb/cdn/attachments/FairProcessingNotice-VMFULLPNV16.pdf?external=true',
  A_SECOND_IN_MS = 1000,
  STATUS_CODE_ACCEPTED = 202,
  EXPERIAN_URL = 'https://www.experian.co.uk/?external=true',
  TRANSUNION_URL = 'https://www.transunion.co.uk/?external=true',
  MONEY_ADVICE_SERVICE_URL = 'https://www.moneyhelper.org.uk/en?external=true',
  CITIZENS_ADVICE_SERVICE_URL = 'https://www.citizensadvice.org.uk/?external=true',
  STEP_CHANGE_SERVICE_URL = 'https://www.stepchange.org/?external=true',
  NATIONAL_DEBT_LINE_SERVICE_URL = 'https://nationaldebtline.org/?external=true',
  UNABLE_LONGER_TERM = 'Unable - longer term',
  UNLIKELY = 'Unlikely',
  NO_MATCH = 'No Match',
  REALLY_GOOD = 'really good',
  PRE_APPROVED = 'Pre-approved',
  GOOD = 'Good',
  UNABLE = 'Unable',
  UNSELECTED_CHECKBOX_VALUE = -1,
  MINIMUM_LOAN_AMOUNT_DIP = 7500,
  MIN_EMAIL_LENGTH_DIP = 6,
  MAX_EMAIL_LENGTH_DIP = 70,
  SERVICES = 'SERVICES',
  ADD_ADDRESS_MANUALLY_TEXT = 'Add address manually',
  ADD_ADDRESS_MANUALLY_TEXT_NTB = 'Enter address manually',
  ADD_ADDRESS_MANUALLY_TEXT_AFTER_LOOKUP = "I can't find my address on the list",
  FIND_BY_POSTCODE_TEXT = 'Find address by postcode',
  FIND_BY_POSTCODE = 'FIND_BY_POSTCODE',
  MANUAL_ENTRY = 'MANUAL_ENTRY',
  VM_FAQS_URL = 'https://virginmoney.com/personal-loans/frequently-asked-questions/',
  LOANS_CONTACT_URL = 'https://virginmoney.com/contact/loans',
  VM_FAQS = 'virginmoney.com/personal-loans/frequently-asked-questions/',
  LOANS_CONTACT = 'virginmoney.com/contact/loans',
  RESUME_LOAN_TYPE = 'resume',
  TRUE_VALUE = 'TRUE',
  FALSE_VALUE = 'FALSE',
  PLUS_LABEL_AMOUNT = 'Click plus to increase the loan amount',
  MINUS_LABEL_AMOUNT = 'Click minus to reduce the loan amount',
  PLUS_LABEL_TERM = 'Click plus to increase the loan term',
  MINUS_LABEL_TERM = 'Click minus to reduce the loan term',
  INCOME_CHANGE_DETAIL_FIELD_POSITION = 13,
  HIDE_CIC_DETAILS_FROM_POSITION = 12,
  FIELDS_DELETE_COUNT = 6,
  ZERO_FIELD_DELETE = 0,
  INCOME_CHANGE_DETAIL_FIELD_POSITION_FOR_ECONOMICALLY_INACTIVE = 11,
  HIDE_CIC_DETAILS_FROM_POSITION_FOR_ECONOMICALLY_INACTIVE = 10;

export const otherEmploymentStatuses = [
  'SELF EMPLOYED',
  'RETIRED',
  'STUDENT',
  'HOUSE PERSON',
  'LONG TERM DISABLED',
  'UNEMPLOYED'
];

export const EMPLOYMENT_STATUSES = [
  'FULL TIME',
  'PART TIME',
  'AGENCY CONTRACT',
  'FIXED TERM CONTRACT'
];

export const MARITAL_STATUSES = ['DIVORCED', 'SEPARATED', 'WIDOWED'];

export const ECONOMICALLY_INACTIVE_STATUSES = [
  'RETIRED',
  'STUDENT',
  'HOUSE PERSON',
  'LONG TERM DISABLED',
  'UNEMPLOYED'
];

export const INDUSTRY_OPTIONS = [
  { id: 'Accountancy Services', labelText: 'Accountancy Services' },
  { id: 'Accounting and Auditing Activities', labelText: 'Accounting and Auditing Activities' },
  { id: 'Adult entertainment', labelText: 'Adult entertainment' },
  { id: 'Advertising', labelText: 'Advertising' },
  {
    id: 'Agricultural Materials & Livestock Sales',
    labelText: 'Agricultural Materials & Livestock Sales'
  },
  { id: 'Air Transport', labelText: 'Air Transport' },
  { id: 'Amusement Arcades', labelText: 'Amusement Arcades' },
  { id: 'Antiques', labelText: 'Antiques' },
  { id: 'Architects', labelText: 'Architects' },
  { id: 'Art Galleries', labelText: 'Art Galleries' },
  { id: 'Artists', labelText: 'Artists' },
  { id: 'Banking (Non-UK Banks)', labelText: 'Banking (Non-UK Banks)' },
  { id: 'Banking (UK Banks)', labelText: 'Banking (UK Banks)' },
  { id: 'Barristers at Law', labelText: 'Barristers at Law' },
  { id: 'Beauty Salons & Nail Bars', labelText: 'Beauty Salons & Nail Bars' },
  { id: 'Boat & Ship Building', labelText: 'Boat & Ship Building' },
  { id: 'Building Societies', labelText: 'Building Societies' },
  {
    id: 'Buying and Selling of Own Real Estate',
    labelText: 'Buying and Selling of Own Real Estate'
  },
  { id: 'Car & Boat Sales', labelText: 'Car & Boat Sales' },
  { id: 'Car Washes', labelText: 'Car Washes' },
  { id: 'Central and Local Government', labelText: 'Central and Local Government' },
  { id: 'Central Clearing Counterparties', labelText: 'Central Clearing Counterparties' },
  { id: 'Chemical & Fertiliser Mining', labelText: 'Chemical & Fertiliser Mining' },
  { id: 'Chemicals', labelText: 'Chemicals' },
  { id: 'Chemists', labelText: 'Chemists' },
  { id: 'Civil Engineering', labelText: 'Civil Engineering' },
  { id: 'Cleaning', labelText: 'Cleaning' },
  { id: 'Clothing & Textile Sales', labelText: 'Clothing & Textile Sales' },
  { id: 'Coal and Solid Fuels', labelText: 'Coal and Solid Fuels' },
  { id: 'Communication Activities', labelText: 'Communication Activities' },
  { id: 'Community Services', labelText: 'Community Services' },
  { id: 'Computer and Technology Services', labelText: 'Computer and Technology Services' },
  { id: 'Construction', labelText: 'Construction' },
  { id: 'Consumer Lending', labelText: 'Consumer Lending' },
  { id: 'Defence Activities', labelText: 'Defence Activities' },
  { id: 'Dental Practice Activities', labelText: 'Dental Practice Activities' },
  { id: 'Digital currency issuers', labelText: 'Digital currency issuers' },
  { id: 'Dismantling of Wrecks', labelText: 'Dismantling of Wrecks' },
  { id: 'Distribution', labelText: 'Distribution' },
  { id: 'Education', labelText: 'Education' },
  {
    id: 'Electrical and Electronic Engineering',
    labelText: 'Electrical and Electronic Engineering'
  },
  { id: 'Electricity', labelText: 'Electricity' },
  { id: 'Embassies & Consulates', labelText: 'Embassies & Consulates' },
  { id: 'Engineering and Metal Goods', labelText: 'Engineering and Metal Goods' },
  { id: 'Event Catering Activities', labelText: 'Event Catering Activities' },
  { id: 'Executors and Trustee Services', labelText: 'Executors and Trustee Services' },
  { id: 'Export Finance', labelText: 'Export Finance' },
  { id: 'Extraction', labelText: 'Extraction' },
  { id: 'Factoring', labelText: 'Factoring' },
  { id: 'Family Trusts', labelText: 'Family Trusts' },
  { id: 'Farming', labelText: 'Farming' },
  { id: 'Film and Associated Services', labelText: 'Film and Associated Services' },
  { id: 'Finance (Regulated Non-UK Companies)', labelText: 'Finance (Regulated Non-UK Companies)' },
  { id: 'Finance (Regulated UK Companies)', labelText: 'Finance (Regulated UK Companies)' },
  { id: 'Finance (Unregulated)', labelText: 'Finance (Unregulated)' },
  { id: 'Financial Leasing', labelText: 'Financial Leasing' },
  { id: 'Fishing', labelText: 'Fishing' },
  { id: 'Food & Beverage Sales', labelText: 'Food & Beverage Sales' },
  { id: 'Food Outlets', labelText: 'Food Outlets' },
  { id: 'Forestry', labelText: 'Forestry' },
  { id: 'Fuel & Chemical Sales', labelText: 'Fuel & Chemical Sales' },
  { id: 'Fund Management Activities', labelText: 'Fund Management Activities' },
  { id: 'Furniture & Hardware Sales', labelText: 'Furniture & Hardware Sales' },
  { id: 'Gambling and Betting', labelText: 'Gambling and Betting' },
  { id: 'Gas', labelText: 'Gas' },
  { id: 'Hazardous Waste', labelText: 'Hazardous Waste' },
  { id: 'High Value Dealer (HMRC Registered)', labelText: 'High Value Dealer (HMRC Registered)' },
  { id: 'High Value Dealer (Unregistered)', labelText: 'High Value Dealer (Unregistered)' },
  { id: 'Hiring of Moveables', labelText: 'Hiring of Moveables' },
  { id: 'Holding Company', labelText: 'Holding Company' },
  { id: 'Horseracing', labelText: 'Horseracing' },
  { id: 'Horticulture & Nurserymen', labelText: 'Horticulture & Nurserymen' },
  { id: 'Hotel Trade', labelText: 'Hotel Trade' },
  { id: 'Insurance Companies', labelText: 'Insurance Companies' },
  { id: 'Investments and Unit Trusts', labelText: 'Investments and Unit Trusts' },
  { id: 'Jewellery Manufacturing', labelText: 'Jewellery Manufacturing' },
  { id: 'Justice and Judicial Activities', labelText: 'Justice and Judicial Activities' },
  { id: 'Livestock', labelText: 'Livestock' },
  { id: 'Machinery & Industrial Sales', labelText: 'Machinery & Industrial Sales' },
  { id: 'Manufacturing', labelText: 'Manufacturing' },
  { id: 'Mechanical Engineering', labelText: 'Mechanical Engineering' },
  { id: 'Medical Practice Activities', labelText: 'Medical Practice Activities' },
  { id: 'Medicinal cannabis-related business', labelText: 'Medicinal cannabis-related business' },
  { id: 'Military Goods', labelText: 'Military Goods' },
  { id: 'Mining and Quarrying', labelText: 'Mining and Quarrying' },
  { id: 'Money Service Business (MSB)', labelText: 'Money Service Business (MSB)' },
  { id: 'Mortgages', labelText: 'Mortgages' },
  { id: 'Motor Mechanic', labelText: 'Motor Mechanic' },
  { id: 'Newsagents', labelText: 'Newsagents' },
  {
    id: 'Nuclear Energy & Radioactive Materials',
    labelText: 'Nuclear Energy & Radioactive Materials'
  },
  { id: 'Nursing', labelText: 'Nursing' },
  { id: 'Oil & Gas Extraction', labelText: 'Oil & Gas Extraction' },
  { id: 'Oil & Gas Processing', labelText: 'Oil & Gas Processing' },
  { id: 'Pawnbrokers & Cheque Encashment', labelText: 'Pawnbrokers & Cheque Encashment' },
  { id: 'Payment Service Providers (Non-Bank)', labelText: 'Payment Service Providers (Non-Bank)' },
  { id: 'Pension Funds', labelText: 'Pension Funds' },
  { id: 'Personal Service Activities', labelText: 'Personal Service Activities' },
  { id: 'Pharmaceutical Sales', labelText: 'Pharmaceutical Sales' },
  { id: 'Political Organisations', labelText: 'Political Organisations' },
  { id: 'Postal Services', labelText: 'Postal Services' },
  { id: 'Precious Metals & Stones (Wholesale)', labelText: 'Precious Metals & Stones (Wholesale)' },
  { id: 'Public Administration', labelText: 'Public Administration' },
  { id: 'Public Houses, Bars and Night Clubs', labelText: 'Public Houses, Bars and Night Clubs' },
  { id: 'Public Order and Safety Activities', labelText: 'Public Order and Safety Activities' },
  { id: 'Publishing', labelText: 'Publishing' },
  { id: 'Pulp', labelText: 'Pulp' },
  { id: 'Radio and TV', labelText: 'Radio and TV' },
  { id: 'Real Estate Management', labelText: 'Real Estate Management' },
  { id: 'Recreation Activities', labelText: 'Recreation Activities' },
  { id: 'Refuse Disposal', labelText: 'Refuse Disposal' },
  {
    id: 'Registered Charities (UK Activity Only)',
    labelText: 'Registered Charities (UK Activity Only)'
  },
  { id: 'Registered International Charities', labelText: 'Registered International Charities' },
  { id: 'Religious Services', labelText: 'Religious Services' },
  { id: 'Repair of Consumer Goods', labelText: 'Repair of Consumer Goods' },
  { id: 'Research and Development', labelText: 'Research and Development' },
  { id: 'Residential Care', labelText: 'Residential Care' },
  { id: 'Road Haulage', labelText: 'Road Haulage' },
  { id: 'Securities & Commodities', labelText: 'Securities & Commodities' },
  { id: 'Security Dealing on Own Account', labelText: 'Security Dealing on Own Account' },
  { id: 'Shell Banks', labelText: 'Shell Banks' },
  { id: 'Social Clubs and Societies', labelText: 'Social Clubs and Societies' },
  { id: 'Social Work', labelText: 'Social Work' },
  { id: 'Solicitors - Registered', labelText: 'Solicitors - Registered' },
  { id: 'Solicitors - Unregistered', labelText: 'Solicitors - Unregistered' },
  { id: 'Sports Clubs', labelText: 'Sports Clubs' },
  { id: 'Taxis', labelText: 'Taxis' },
  { id: 'Telecommunications', labelText: 'Telecommunications' },
  { id: 'Textiles', labelText: 'Textiles' },
  { id: 'Timber and Building Material Sales', labelText: 'Timber and Building Material Sales' },
  { id: 'Tobacco', labelText: 'Tobacco' },
  {
    id: 'Tobacco, Drug & Pharmaceutical Farming',
    labelText: 'Tobacco, Drug & Pharmaceutical Farming'
  },
  { id: 'Tourism', labelText: 'Tourism' },
  { id: 'Tourist & Short Stay Accommodation', labelText: 'Tourist & Short Stay Accommodation' },
  { id: 'Trade Associations', labelText: 'Trade Associations' },
  { id: 'Transport', labelText: 'Transport' },
  { id: 'Transport Equipment', labelText: 'Transport Equipment' },
  { id: 'Travel Agency Activities', labelText: 'Travel Agency Activities' },
  { id: 'Unregistered Charities', labelText: 'Unregistered Charities' },
  { id: 'Uranium Mining', labelText: 'Uranium Mining' },
  { id: 'Veterinary Surgeons', labelText: 'Veterinary Surgeons' },
  { id: 'Warehousing & Storage', labelText: 'Warehousing & Storage' },
  { id: 'Water', labelText: 'Water' },
  { id: 'Weapons and Ammunition Manufacturing', labelText: 'Weapons and Ammunition Manufacturing' }
];

export const EXISTING_ACCOUNT_RADIO_YES_OPTION = 'Yes';
export const EXISTING_ACCOUNT_RADIO_NO_OPTION = 'No.';

export const YES = 'Yes';
export const NO = 'No';

export const EMPLOYMENT_JOB_LEVEL_STATUSES = {
  EMPLOYEE: 'EMPLOYEE',
  CONTRACTOR: 'CONTRACTOR',
  KEY_CONTROLLER: 'KEY CONTROLLER',
  BUSINESS_OWNER: 'BUSINESS OWNER'
};

export const EMPLOYMENT_JOB_LEVEL_DESCRIPTIONS = {
  CONTRACTOR: 'You work for different businesses for set periods of time, but are not an employee.',
  KEY_CONTROLLER:
    'You have more direct control over a business and take part in governance or senior exec activities.'
};

export const SELF_EMPLOYED = 'SELF EMPLOYED';
export const YES_OPTION = 'YES';

export const EMPLOYMENT_JOB_LEVEL_OPTIONS = [
  { label: 'Employee', value: EMPLOYMENT_JOB_LEVEL_STATUSES.EMPLOYEE },
  { label: 'Business owner', value: EMPLOYMENT_JOB_LEVEL_STATUSES.BUSINESS_OWNER },
  {
    label: 'Contractor',
    value: EMPLOYMENT_JOB_LEVEL_STATUSES.CONTRACTOR
  },
  {
    label: 'Key controller',
    value: EMPLOYMENT_JOB_LEVEL_STATUSES.KEY_CONTROLLER,
    subLabelText: EMPLOYMENT_JOB_LEVEL_DESCRIPTIONS.KEY_CONTROLLER
  }
];

export const PREREQUISITE_LIST_ITEMS = [
  'Your bank or building society details',
  'Photo ID such as your passport or driving licence'
];

export const UK_ONLY_CITIZENSHIP = ['', 'UK only'];
